module.exports = __webpack_public_path__ + "assets/img/in_(5).29124351.gif";